"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var config_1 = __importDefault(require("../../config"));
var avatar_description_enum_1 = __importDefault(require("../../shared/enums/avatar-description.enum"));
var avatar_priority_enum_1 = __importDefault(require("../../shared/enums/avatar-priority.enum"));
var avatar_style_enum_1 = __importDefault(require("../../shared/enums/avatar-style.enum"));
var position_enum_1 = __importDefault(require("../../shared/enums/position.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var getIconEnumValue_1 = __importDefault(require("../../shared/utilities/getIconEnumValue"));
var enhanced_icon_1 = __importDefault(require("../enhanced-icon"));
require("./avatar.scss");
function Avatar(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!props.avatar) {
        // if we get here without avatar details then display nothing, this prevents a system crash
        return null;
    }
    var base = config_1.default.defaults.basePaths.avatars;
    var avatarStyle = (_a = props.avatarStyle) !== null && _a !== void 0 ? _a : avatar_style_enum_1.default.BODY;
    var headOnly = avatarStyle === avatar_style_enum_1.default.HEAD;
    var avatarType = (_b = props.avatarType) !== null && _b !== void 0 ? _b : avatar_priority_enum_1.default.DEFAULT;
    var avatarSplit = (_c = props.avatar) === null || _c === void 0 ? void 0 : _c.split(":");
    var avatar = "";
    var fileType = "";
    if (avatarSplit) {
        fileType = avatarSplit[0], avatar = avatarSplit[1];
        avatar = avatar === null || avatar === void 0 ? void 0 : avatar.toLowerCase();
    }
    var key = avatar.toUpperCase();
    var updatedProps = __assign(__assign({}, props), { icon: "".concat(base).concat(avatar, "/").concat(avatarType, ".").concat(fileType), title: props.showTitle ? props.avatar : undefined, textPosition: position_enum_1.default.BOTTOM, squared: true, theme: props.theme, alt: props.showTitle
            ? ((_f = (_e = (_d = props.alt) === null || _d === void 0 ? void 0 : _d.replace(/</g, "&lt;").replace(/>/g, "&gt;")) !== null && _e !== void 0 ? _e : avatar_description_enum_1.default[key]) !== null && _f !== void 0 ? _f : "")
            : "" });
    return (react_1.default.createElement("div", { className: (0, classMap_1.default)("mpng-ux-avatar", "overflow-hidden d-inline-block", props.className), style: {
            transform: "rotate(".concat((_g = props.rotation) !== null && _g !== void 0 ? _g : 0, "deg)"),
            height: headOnly ? (0, getIconEnumValue_1.default)(props.size) / 2 : undefined
        } },
        react_1.default.createElement(enhanced_icon_1.default, __assign({}, updatedProps))));
}
exports.default = Avatar;
